import { WarehouseTenantDTO, WarehouseTenantOptions } from '@invenco/warehousing-interface';

import { useGateways } from '../../../../gateways/GatewayProvider';
import { useEntityDetailsQuery, useGatewayMutation } from '../../../../shared/hooks/queries';

export function useTenant(id?: string) {
  const { warehousingGateway } = useGateways();

  const {
    data: warehouseTenant,
    isLoading,
    refetch: refetchTenant,
  } = useEntityDetailsQuery<WarehouseTenantDTO>({
    parentKey: 'warehouseTenants',
    id,
    isNew: false,
    query: (fetchId, { signal }) => warehousingGateway.getWarehouseTenant(fetchId, { signal }),
  });

  const { mutate: updateWarehouseTenant, isPending: isUpdatingWarehouseTenant } =
    useGatewayMutation<WarehouseTenantDTO, WarehouseTenantOptions>({
      mutationFn: (warehouseTenantOptions) =>
        warehousingGateway.updateWarehouseTenant(id!, {
          warehouseTenantOptions: {
            ...(warehouseTenant?.warehouseTenantOptions ?? {}),
            ...warehouseTenantOptions,
          },
        }),
      linkedQuery: ['warehouseTenants', id],
      successMessage: 'Tenant updated',
    });

  return {
    warehouseTenant,
    isLoading,
    refetchTenant,
    updateWarehouseTenant,
    isUpdatingWarehouseTenant,
  };
}
